module.exports = __webpack_public_path__ + "img/txt-b-1.4cacfecf.png";